var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 col-sm-12"},[(_vm.$route.name === 'projectSettingsPresets')?_c('PresetsTable'):_vm._e(),(_vm.$route.name === 'projectSettingsPresetsCreate')?_c('PresetsCreate'):_vm._e(),(_vm.$route.name === 'projectSettingsPresetsEdit')?_c('PresetsEdit'):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }